module.exports = __webpack_public_path__ + "media/images/mail_new-148975914d3331aba7bdc332b80b47c2.svg";